import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";
import "../css/Layout.css";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const hideSidebarRoutes = ["/", "/signup", "/verify-otp", "/unauthorized"];
  const hideSidebar =
     !user || hideSidebarRoutes.includes(location.pathname);

  if (hideSidebar) {
    return children;
  }

    const handleLogout = () => {
      setMenuOpen(false);
      logout();
      navigate("/"); // Redirect to login page
    };

  return (
    <div className="app-layout">
      {/* Mobile Header */}
      <div className="mobile-header">
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
        <span className="mobile-role">{user?.role ? user.role.toUpperCase() : ""}</span>
      </div>

      {/* Sidebar */}
      <aside className={`sidebar-layout ${menuOpen ? "open" : ""}`}>
        <div className="sidebar-header-layout">
          <p className="role-layout">{user?.role ? user.role.toUpperCase() : ""}</p>
        </div>

        <nav className="menu-layout">
          <Link to="/profile" onClick={() => setMenuOpen(false)}>
            Profile
          </Link>

          {user.role === "parent" && (
            <Link to="/parent" onClick={() => setMenuOpen(false)}>
              Dashboard
            </Link>
          )}
          {user.role === "learner" && (
            <>
              <Link to="/child" onClick={() => setMenuOpen(false)}>
                Dashboard
              </Link>
              <Link to="/child/checkin" onClick={() => setMenuOpen(false)}>
                Check-in
              </Link>
            </>
          )}
          {user.role === "educator" && (
            <Link to="/educator" onClick={() => setMenuOpen(false)}>
              Dashboard
            </Link>
          )}
          {user.role === "institution" && (
            <Link to="/institution" onClick={() => setMenuOpen(false)}>
              Dashboard
            </Link>
          )}

          <button className="logout-btn-layout" onClick={handleLogout}>
            Logout
          </button>
        </nav>
      </aside>

      {/* Content */}
      <main className="content-layout">{children}</main>
    </div>
  );
}